export default class BasicInfo {
    
    name = null
    email = null
    phone1 = null
    phone2 = null
    description = null
    categories = null

    constructor(name, email, phone1, phone2, description, categories) {
        this.name = name
        this.email = email
        this.phone1 = phone1
        this.phone2 = phone2
        this.description = description
        this.categories = categories
    }
}